import { createContext } from "react";


export const DiscountContext = createContext();
